import { render, staticRenderFns } from "./news_detail.vue?vue&type=template&id=bdec1758&scoped=true"
import script from "./news_detail.vue?vue&type=script&lang=js"
export * from "./news_detail.vue?vue&type=script&lang=js"
import style0 from "./news_detail.vue?vue&type=style&index=0&id=bdec1758&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec1758",
  null
  
)

export default component.exports